import React, { useEffect, useState } from "react";
import plusIcon from "../../../assets/images/Svg/plusIcon.svg";
import AddSocialHistory from "./AddSocialHistory";
import { Modal } from "antd";
import MedicalService from "../../../Services/MedicalService";
import dayjs from "dayjs";
import { FiPlus } from "react-icons/fi";

function SocialHistory(props) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [socialHistoryData, setSocialHistoryData] = useState([]);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  useEffect(() => {
    patientSocialHistory();
  }, [props.selectedPatient.patientId]);

  const handleSocialClick = () => {
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    patientSocialHistory();
  };

  const patientSocialHistory = () => {
    let payload = {
      patientId: props.selectedPatient.patientId,
      status: 1,
    };
    MedicalService.PatientSocialHistory(payload)
      .then((result) => {
        setSocialHistoryData(result.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <div>
      {/* <div className="card h-[300px] m-5 border rounded-lg">
        <div className="header h-[15%] bg-secondaryColor flex items-center justify-between  rounded-lg p-2">
          <h1 className="font-bold text-normal  text-white ">Social History</h1>
          <img
            src={plusIcon}
            onClick={() => handleSocialClick()}
            className="h-10 w-10 cursor-pointer"
            alt=""
          />
        </div>
        <div className="body h-[70%] items-center bg-brand-lightBg overflow-y-auto" id="unquie-scroll">
          {socialHistoryData.length > 0
            ? socialHistoryData.map((user, i) => (
                <div>
                  <div key={i} className="mt-3 p-2 text-sm flex flex-col gap-2">
                    <h4 className="font-medium text-black">Social History : <span className="font-medium text-gray-500">{user.description}</span> </h4>
                    <h4 className="font-medium text-black">Occupation : <span className="font-medium text-gray-500">{user.occupation}</span></h4>
                    <h4 className="font-medium text-black">Marital Status: <span className="font-medium text-gray-500">{user.maritalStatus}</span></h4>
                    <h4 className="font-medium text-black">Social relations with family: <span className="font-medium text-gray-500">{user.familyRelation}</span></h4>
                    <h4 className="font-medium text-black">
                      Social relations with friends: <span className="font-medium text-gray-500">{user.friendsRelation}</span>
                    </h4>
                    <h4 className="font-medium text-black">
                      Social relations with community: <span className="font-medium text-gray-500">{user.communityRelation}</span>
                    </h4>
                    <h4 className="font-medium text-black">
                      Social relations with people at work :{" "}
                      <span className="font-medium text-gray-500">{user.colleagueRelation}</span>
                    </h4>
                  </div>
                  <div className="ml-2 ">
                      <span className="font-medium text-gray-500 text-sm">
                      Onset date :{" "}
                      {dayjs(user.givenDate).format('YYYY-MM-DD')}
                      </span>
                  
                    </div>
                  <hr className="my-4 border-gray-300" />
                </div>
              ))
            : null}
        </div>
        <div className="footer h-[10%]  bg-secondaryColor rounded-md"></div>
      </div> */}
      <div
        className="bg-white rounded-xl border border-gray-200 shadow-sm w-full"
        id="unquie-scroll"
      >
        <div className="flex justify-between items-center p-3">
          <h3 className="text-sm font-bold text-gray-700">Social History</h3>
          <div className="flex items-center gap-2 text-blue-500 font-sans font-medium underline text-xs cursor-pointer">
            <div
              onClick={() => handleSocialClick()}
              className="w-6 h-6 rounded-full flex items-center justify-center bg-primaryColor"
            >
              <FiPlus className="text-white w-4 h-4" />
            </div>
            {/* <HiPlusCircle className="text-primaryColor w-7 h-7"/> */}
          </div>
        </div>
        <hr />
        <div className="h-44 p-3 overflow-y-scroll flex flex-col gap-3 scrollWidth">
          {socialHistoryData.length > 0 ? (
            socialHistoryData.map((user, i) => (
              <div
                className="relative"
                onMouseEnter={() => setHoveredIndex(i)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <div className="overflow-y-scroll pr-2 scrollWidth flex flex-col gap-2">
                  <div className="bg-[#FFFDF4] border border-[#EFD659] border-l-4 rounded-lg p-3 text-xs text-gray-700 flex flex-col gap-2">
                    <p>
                      <strong>Social History :</strong> {user.description}
                    </p>
                    <p>
                      Onset Date : {dayjs(user.givenDate).format("YYYY-MM-DD")}
                    </p>
                  </div>
                </div>

                {hoveredIndex === i && (
                  <div
                    className="fixed bg-[#585858] text-white text-xs rounded-lg shadow-lg p-3 z-50"
                    style={{ top: "200px", left: "100px" }}
                  >
                    {" "}
                    {user.description && (
                      <p>
                        <strong>Social History :</strong> {user.description}
                      </p>
                    )}
                    {user.occupation && (
                      <p>
                        <strong>Occupation :</strong> {user.occupation}
                      </p>
                    )}
                    {user.maritalStatus && (
                      <p>
                        <strong>Marital Status:</strong> {user.maritalStatus}
                      </p>
                    )}
                    {user.familyRelation && (
                      <p>
                        <strong>Social relations with family:</strong>{" "}
                        {user.familyRelation}
                      </p>
                    )}
                    {user.friendsRelation && (
                      <p>
                        <strong>Social relations with friends:</strong>{" "}
                        {user.friendsRelation}
                      </p>
                    )}
                    {user.communityRelation && (
                      <p>
                        <strong>Social relations with community: </strong>{" "}
                        {user.communityRelation}
                      </p>
                    )}
                    {user.colleagueRelation && (
                      <p>
                        <strong>Social relations with people at work: </strong>{" "}
                        {user.colleagueRelation}
                      </p>
                    )}
                    <p>
                      <strong>Onset date:</strong>{" "}
                      {dayjs(user.givenDate).format("YYYY-MM-DD")}
                    </p>
                  </div>
                )}
              </div>
            ))
          ) : (
            <div></div>
          )}
        </div>
      </div>

      {isModalVisible && (
        <Modal
          title={
            <span className="text-base font-bold font-sans">
              Add Social History
            </span>
          }
          visible={isModalVisible}
          onOk={() => handleCloseModal()}
          centered={true}
          footer={null}
          onCancel={() => handleCloseModal()}
          okText="Submit"
          cancelText="Cancel"
          width={610}
          maskClosable={false}
        >
          <AddSocialHistory
            selectedPatient={props.selectedPatient}
            onClose={() => handleCloseModal()}
          />
        </Modal>
      )}
    </div>
  );
}

export default SocialHistory;
